// @ts-nocheck
/* eslint-disable */

"use client";

import {
  Column,
  Cover,
  Heading,
  Flex,
  Button,
  Icon,
  Row,
  Spacer,
} from "politicamente-informados-ds";

import DisplayImage from "@/components/common/DisplayImage/DisplayImage";
import NavigationEvents from "@/components/common/NavigationEvents/NavigationEvents";
import { Suspense } from "react";
import { styled } from "styled-components";
import { variables } from "politicamente-informados-ds";
import displayBlock from "@/lib/wordpress/blocks/displayBlock";

export const StyledWishButton = styled.div`
  button {
    box-shadow: unset;
    border-radius: 4px;
    border: 1px solid ${variables.colors.gray50};
    color: ${variables.colors.gray50};
    padding: 8px;

    &:before {
      background: ${variables.colors.gray50};
    }
    &:hover {
      color: ${variables.colors.white};
    }
  }
`;

const StyledCover = styled(Cover)`
  color: white;
  height: 100%;
  align-items: end;
  padding: 28px 3rem;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      0deg,
      rgba(29, 29, 29, 0.9) 0%,
      rgba(29, 29, 29, 0) 100%
    );

    z-index: 1;
    &:first-child{
      background-color:red;
    }
  }


  @media (max-width: ${variables.responsiveMedia}) {
    padding: 28px 0.5rem;
  }
`;

const EuropaPost = (post: Record<string, unknown>) => {

  const { title, translatedURI, acf } = post;

  return (
    <>
      <Suspense>
        <NavigationEvents
          translatedURI={translatedURI || ""}
          acf={{ page_style: "light", header_absolute: true }}
        />
      </Suspense>
      <StyledCover
        minHeight={"40dvh"}
        imageElement={
          <div className="elements_animated masked h-100">
            <DisplayImage
              alt={title ? title : ""}
              url={acf?.photo_header?.url || ""}
              fill={true}
              style={{ objectFit: "cover" }}
            />
            <div className="elements_animated_mask"></div>
          </div>
        }
        overlayOpacity={0.6}
        animation="masked"
      >
        <div style={{ alignSelf: "end"}} className="h-100">
          <Row align="flex-end" className="h-100">
            <Column>
              <Heading tag="h1" size="h1" className="fw-semibold">
                {title}
              </Heading>
            </Column>
          </Row>
        </div>
      </StyledCover>


      <Spacer height={4} />
      {!!(post?.blocks as [])?.length &&
        (post?.blocks as []).map((block: BlocksProps, index: number) => {
          return displayBlock(block, index);
        })}

      <Spacer height={4} />
    </>
  );
};
export default EuropaPost;
